window.bssB2BHooks = window.bssB2BHooks || {
    actions: {}, filters: {}, 
};
window.BSS_B2B = window.BSS_B2B || {}; 
window.BSS_B2B.addAction = (tag, callback) => {
    window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
    window.bssB2BHooks.filters[tag] = value;
};

/* ===========================================================================
   PRICING MODEL (read this before changing anything)

   Catalog list prices are stored EX VAT. Shopify adds tax at checkout
   (all markets are ADD_TAXES_AT_CHECKOUT and the shop default is
   tax-exclusive), so the number in the price list is a clean net figure.

   That gives the margin table two jobs, and only one of them touches tax:

     MARGIN  = (listPriceEx - wholesaleCost) / listPriceEx
               Both sides are ex VAT, so this is exact in every country on
               earth, whether or not we hold a tax rate for it. Tax is not
               involved at all.

     RRP     = listPriceEx x (1 + rate)
               Display only, and ONLY where we genuinely know the rate.
               Everywhere else the RRP is shown ex VAT and labelled as such.
   =========================================================================== */

/* ---------------------------------------------------------------------------
   CONSUMER TAX RATES  (display only - see above)

   Scope is deliberately narrow: only the 31 countries that have their own
   Planora market, where the ex-VAT list price was derived from a specific
   rate and grossing it back up returns a meaningful shelf price.

     EU bands (26)  price set so listEx x (1 + rate) = 99.00 / 29.00
     GB, SE, NO, AU, CA   single-rate markets, converted the same way

   Every other country - the ~160 in Rest of World - resolves to 0 and the
   chart shows an honest "RRP" with no VAT claim. That is intentional. Those
   markets share one EUR list at a flat export price, span every tax regime
   from 0% to 27%, and are usually reselling into a currency we do not price
   in. Asserting an inc-VAT figure there would be a guess dressed as a fact.

   Shopify's own rate ALWAYS wins where one exists, so registered markets
   cannot drift from what is really charged at checkout.

   >>> Standard VAT rates, current as of July 2026. They do change - Estonia
   >>> moved 22->24% in Jul 2025, Romania 19->21% in Aug 2025.
   >>> Nothing here affects tax collection or checkout.

   Note on CA: 5% federal GST only. Provinces add PST/HST (up to ~15%
   combined), so the Canadian RRP is understated in most provinces.
   --------------------------------------------------------------------------- */
var PLANORA_ILLUSTRATIVE_VAT = {
  // EU 19%
  DE: 0.19, CY: 0.19,
  // EU 20%
  AT: 0.20, BG: 0.20, FR: 0.20,
  // EU 21%
  BE: 0.21, CZ: 0.21, ES: 0.21, LT: 0.21, LV: 0.21, NL: 0.21, RO: 0.21,
  // EU 22%
  IT: 0.22, SI: 0.22,
  // EU 23%
  IE: 0.23, PL: 0.23, PT: 0.23, SK: 0.23,
  // EU 24% pooled
  DK: 0.25, HR: 0.25, EE: 0.24, GR: 0.24, FI: 0.255, LU: 0.17, HU: 0.27, MT: 0.18,
  // Own markets outside the EU
  GB: 0.20, SE: 0.25, NO: 0.25, AU: 0.10, CA: 0.05
};

function planoraResolveTaxRate() {
  var shopifyRate = Number((window.BSS_B2B && window.BSS_B2B.countryTax) || 0);
  if (shopifyRate > 0) {
    return { rate: shopifyRate, isIllustrative: false };
  }
  var code = (window.BSS_B2B && window.BSS_B2B.countryCode) || '';
  var fallback = PLANORA_ILLUSTRATIVE_VAT[code];
  return {
    rate: typeof fallback === 'number' ? fallback : 0,
    isIllustrative: typeof fallback === 'number' && fallback > 0
  };
}

function marginTableTemplate(rule, tableTempData, commonData) {
  const rows = [...tableTempData.values()];
  const table = new Map();

  const taxRate = planoraResolveTaxRate().rate;

  // Only claim "inc. VAT" when a rate is actually applied, otherwise the
  // header promises tax that isn't in the number.
  const rrpHeading = taxRate > 0 ? 'RRP inc. VAT' : 'RRP';

  table.set('head', [
    '<th class="bss-qb-margin__th">Qty</th>',
    '<th class="bss-qb-margin__th" style="white-space:nowrap;">Unit price</th>',
    '<th class="bss-qb-margin__th" style="white-space:nowrap;">' + rrpHeading + '</th>',
    '<th class="bss-qb-margin__th" style="white-space:nowrap;">Your margin</th>',
  ]);

  // The catalog list price - stored EX VAT.
  const listEx = Number(rule?.price ?? 0);

  // Grossed up purely for display where we hold a rate. Rounded to 2dp so
  // prices designed to land on a round retail figure do so cleanly
  // (74.17 x 1.20 = 89.004 -> 89.00). Where rate is 0 the ex-VAT list price
  // is shown as-is.
  const rrpDisplay = taxRate > 0
    ? Math.round(listEx * (1 + taxRate) * 100) / 100
    : listEx;

  const rrpFormatted = rrpDisplay > 0 ? BSS_B2B.formatMoney(rrpDisplay) : '—';

  rows.forEach((row, i) => {
    const isLast = i === rows.length - 1;
    const isHighlight = i >= rows.length - 2;

    const from = row.originValueFrom;
    const to = row.originValueTo;
    const qtyLabel = to == null || String(to).length === 0 ? `${from}+` : `${from}–${to}`;

    const costNumeric = pickCostNumeric(row);
    const costFormatted = costNumeric > 0
      ? BSS_B2B.formatMoney(costNumeric)
      : row.priceValue;

    // Both sides ex VAT - no tax rate involved, so this is exact everywhere.
    let marginPct = 0;
    if (listEx > 0 && costNumeric > 0) {
      marginPct = Math.round(((listEx - costNumeric) / listEx) * 100);
    }

    const marginClass = isHighlight
      ? 'bss-qb-margin__pct bss-qb-margin__pct--high'
      : 'bss-qb-margin__pct';
    const sparkle = isLast ? ' ✦' : '';

    const cellExtra = (extra) => isLast ? `bss-qb-margin__cell--last ${extra}` : extra;

    table.set(String(row.id), [
      `<td class="${cellExtra('bss-qb-margin__td')}">${qtyLabel}</td>`,
      `<td class="${cellExtra('bss-qb-margin__td')}">${costFormatted}</td>`,
      `<td class="${cellExtra('bss-qb-margin__td')}">${rrpFormatted}</td>`,
      `<td class="${cellExtra('bss-qb-margin__td')}"><span class="${marginClass}">${marginPct}%${sparkle}</span></td>`,
    ]);
  });

  return table;
}

function pickCostNumeric(row) {
  if (typeof row.originDiscountedPrice === 'number' && row.originDiscountedPrice > 0) {
    return row.originDiscountedPrice;
  }
  if (typeof row.discountedPrice === 'number' && row.discountedPrice > 0) {
    return row.discountedPrice;
  }
  const text = String(row.priceValue ?? '');
  const match = text.match(/[\d.,]+/);
  if (!match) return 0;
  const cleaned = match[0]
    .replace(/\.(?=\d{3}(\D|$))/g, '')
    .replace(',', '.');
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : 0;
}

BSS_B2B.addFilter('custom:qb/table_template', (defaultTemplate, args) => {
  return marginTableTemplate;
});

// ---------------------------------------------------------------------------
// Footnote under the volume-pricing table.
//
// Shown only where a rate is actually applied - in Rest of World the RRP
// carries no VAT and there is nothing to explain.
//
// Build notes:
//  - An extra <tr> in the template gets dropped: the app only renders rows it
//    has pricing data for.
//  - Product page and catalog popup use different outer containers, so we
//    anchor to the <table> itself, which both share.
//  - Colours are sampled from the table's own last row. Row backgrounds sit on
//    the <tr>, not the <td>, so the <tr> must be checked too - otherwise we
//    fall through to the table's grey or the modal overlay behind it.
// ---------------------------------------------------------------------------
(function () {
  var NOTE_CLASS = 'bss-qb-margin__note';

  function isOpaque(color) {
    return color && color !== 'transparent' && !/rgba\([^)]*,\s*0\s*\)/.test(color);
  }

  function firstOpaqueBg(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i]) continue;
      var c = getComputedStyle(nodes[i]).backgroundColor;
      if (isOpaque(c)) return c;
    }
    return '';
  }

  function addNote(tableEl) {
    if (!tableEl || !tableEl.parentElement) return;

    if (!(planoraResolveTaxRate().rate > 0)) return;

    var next = tableEl.nextElementSibling;
    if (next && next.classList && next.classList.contains(NOTE_CLASS)) return;

    var bodyRows = tableEl.querySelectorAll('tbody tr');
    var lastRow = bodyRows.length ? bodyRows[bodyRows.length - 1] : null;
    var lastCell = lastRow ? lastRow.querySelector('td') : null;
    var headCell = tableEl.querySelector('th');

    var bg = firstOpaqueBg([lastCell, lastRow, headCell, tableEl]);
    var color = headCell ? getComputedStyle(headCell).color : '';

    var note = document.createElement('div');
    note.className = NOTE_CLASS;
    note.textContent = 'RRP shown incl. VAT. Your price and margin are excl. VAT.';
    note.style.cssText =
      'font-size:1.2rem;line-height:1.4;padding:10px 16px 12px;opacity:0.7;' +
      (bg ? 'background:' + bg + ';' : '') +
      (color ? 'color:' + color + ';' : '');

    tableEl.parentElement.insertBefore(note, tableEl.nextSibling);
  }

  function scan() {
    document.querySelectorAll('table.quantity_break_table').forEach(addNote);
  }

  function start() {
    scan();
    var observer = new MutationObserver(function () { scan(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
